/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/**
 * Exports
*/

/**
 * 
 */
export function DisplayToggle(props) {
  /** States **/

  const [ activeDisplayMode, setActiveDisplayMode ] = useState( props.activeMode || props.defaultMode );

  /** Side-Effects **/

  useEffect(() => {
    setActiveDisplayMode( props.activeMode || props.defaultMode );
  }, [ props.activeMode ]);

  /** Renderers **/

  /**
   * 
   */
  const renderMode = (mode) => {
    const config = {
      activeDisplayMode, setActiveDisplayMode
    };
    
    return (
      typeof mode === 'function'
        ? React.createElement(mode, config)
        : React.cloneElement(mode, config)
    );
  };

  /**
   * 
   */
  const renderChildren = () => (
    React.Children.map(
      props.children, child => (
        child.props.mode === activeDisplayMode
          ? renderMode(child)
          : null
      )
    )
  );

  /** Output **/

  return (
    props.children
      ? renderChildren()
      : renderMode(props.modes[activeDisplayMode])
  );
}

DisplayToggle.propTypes = {
  activeMode: PropTypes.string,
  defaultMode: PropTypes.string.isRequired,
  modes: PropTypes.object
};